/**
 * Test disabling the auto modal on select discover pages
 * PRD: https:www.notion.so/faire/Signup-auto-modal-test-for-SEO-85b9d37a09264fa8a5a665d66970a83c#7aa4ac0956e44e8caf694cf71ead0656
 */
export const ENABLE_AUTO_MODAL_DISABLE_TEST_091624 = 'ENABLE_AUTO_MODAL_DISABLE_TEST_091624';
